import React from 'react';
import { useTranslation } from 'react-i18next';

export const LeadLikelihoodLegend = () => {
  const { t } = useTranslation('common');

  return (
    <div id="parcels-score" className="legend">
      <h4 style={{display: 'inline-block'}}>{t('map.legend.legend_title.parcel')} &nbsp;<i className="fa fa-info-circle" display="inline-block" data-toggle="tooltip" data-placement="left" title="BlueConduit uses a mathematical model to predict whether water service lines might be made of lead or galvanized steel when the material has not yet been verified. For more information, click 'FAQ' in the menu above."></i></h4>
      <div><span style={lead}></span>{t('map.legend.city_level.lead')}</div>
      <div><span style={high_like}></span>{t('map.legend.city_level.high_like')}</div>
      <div><span style={med_like}></span>{t('map.legend.city_level.med_like')}</div>
      <div><span style={low_like}></span>{t('map.legend.city_level.low_like')}</div>
      <div><span style={non_lead}></span>{t('map.legend.city_level.non_lead')}</div>
      <div><span style={unknown}></span>{t('map.legend.city_level.unknown')}</div>
    </div>
  );
}

const lead = {backgroundColor: `${process.env.REACT_APP_MAP_LEAD}`, border: "solid 1px #000000"}
const high_like = {backgroundColor: `${process.env.REACT_APP_MAP_HIGH_LIKE}`, border: "solid 1px #000000"}
const med_like = {backgroundColor: `${process.env.REACT_APP_MAP_MED_LIKE}`, border: "solid 1px #000000"}
const low_like = {backgroundColor: `${process.env.REACT_APP_MAP_LOW_LIKE}`, border: "solid 1px #000000"}
const non_lead = {backgroundColor: `${process.env.REACT_APP_MAP_NON_LEAD}`, border: "solid 1px #000000"}
const unknown = {backgroundColor: `${process.env.REACT_APP_MAP_UNKNOWN}`, border: "solid 1px #000000"}

export default LeadLikelihoodLegend;
